import React, { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { theme } from "../theme";
import { AdminContext } from "../AdminContext";
import Button from "./Button";

const HeaderContainer = styled.header`
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  padding: 0 24px;
  background: ${theme.colors.surface};
  border-bottom: 1px solid ${theme.colors.borderLight};
  box-shadow: ${theme.shadows.sm};
  font-family: ${theme.fonts.body};

  > div {
    display: flex;
    justify-content: space-between;
    padding: 32px;
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
  }
  }
`;

const Title = styled.h1`
  font-size: 18px;
  font-weight: 600;
  color: ${theme.colors.text};
`;

const NavSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const NavLink = styled.a`
  font-size: 14px;
  color: ${({ $active }) =>
    $active ? theme.colors.text : theme.colors.textSecondary};
  font-weight: ${({ $active }) => ($active ? "500" : "initial")};
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: ${theme.colors.text};
  }
`;

const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const UserStatus = styled.span`
  font-size: 13px;
  color: ${theme.colors.textSecondary};
`;

const AdminHeader = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isAuthenticated, user, logout } = useContext(AdminContext);

  const displayName =
    (user && (user.name || user.preferred_username || user.email)) ||
    "Администратор";

  return (
    <HeaderContainer>
      <div>
        <Title>Определитель декоративной бумаги в книжном переплёте</Title>
        <NavSection>
          {isAuthenticated && (
            <>
              <NavLink
                $active={pathname.includes("blocks")}
                onClick={() => navigate("/opredelitel/admin/blocks")}
              >
                Узоры
              </NavLink>
              <NavLink
                $active={pathname.includes("papers")}
                onClick={() => navigate("/opredelitel/admin/papers")}
              >
                Типы бумаги
              </NavLink>
              <NavLink
                $active={pathname.includes("logs")}
                onClick={() => navigate("/opredelitel/admin/logs")}
              >
                Журнал
              </NavLink>
            </>
          )}
        </NavSection>
        <UserSection>
          {isAuthenticated && <UserStatus>{displayName}</UserStatus>}
          {isAuthenticated && (
            <Button $variant="ghost" $size="sm" onClick={logout}>
              Выйти
            </Button>
          )}
        </UserSection>
      </div>
    </HeaderContainer>
  );
};

export default AdminHeader;
